import { render, staticRenderFns } from "./subject-list.vue?vue&type=template&id=5fff8533&scoped=true"
import script from "./subject-list.vue?vue&type=script&lang=js"
export * from "./subject-list.vue?vue&type=script&lang=js"
import style0 from "./subject-list.vue?vue&type=style&index=0&id=5fff8533&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fff8533",
  null
  
)

export default component.exports